import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonLabel } from '@ionic/vue';
import BaseButton from '@/components/BaseButton.vue';
import NewsAction from '@/types/NewsAction';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsButton',
  props: {
    action: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseButton, {
    class: "news-button__action-button",
    color: "light",
    href: _ctx.action.link,
    target: "_blank",
    icon: _ctx.action.icon,
    iconSlot: "start"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonLabel), {
        class: "news-button__title",
        "text-wrap": ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.action.title), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["href", "icon"]))
}
}

})